var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiCurrencyItem2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9991 30.859C79.9991 41.5206 71.3904 50.1635 60.771 50.1635C50.1517 50.1635 41.543 41.5206 41.543 30.859C41.543 20.1974 50.1517 11.5544 60.771 11.5544C71.3904 11.5544 79.9991 20.1974 79.9991 30.859Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.1348,
    y: -26.9316,
    width: 122.723,
    height: 115.864
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_0_974_11211_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    d: "M11.8777 29.7164L3.12182 7.80942C1.97785 4.94724 4.86662 2.13263 7.6819 3.36641L63.5285 27.8408C66.275 29.0445 66.275 32.9557 63.5285 34.1594L7.68191 58.6338C4.86663 59.8676 1.97786 57.053 3.12183 54.1908L11.8777 32.2839C12.207 31.46 12.207 30.5403 11.8777 29.7164Z",
    fill: "url(#paint0_linear_974_11211)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -27.2207,
    y: -27.0181,
    width: 122.895,
    height: 116.036
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(15px)",
      clipPath: "url(#bgblur_1_974_11211_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 30,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6477 3.4454C4.90281 2.24246 2.08626 4.98671 3.20163 7.77734L11.9575 29.6843C12.295 30.5288 12.295 31.4715 11.9575 32.316L3.20163 54.2229C2.08626 57.0135 4.90281 59.7578 7.64771 58.5548L63.4943 34.0804C66.1722 32.9068 66.1722 29.0934 63.4943 27.9198L7.6477 3.4454ZM3.0423 7.84152C1.86973 4.90779 4.83072 2.02281 7.71638 3.28744L63.563 27.7619C66.3782 28.9956 66.3782 33.0046 63.563 34.2384L7.71639 58.7128C4.83072 59.9774 1.86974 57.0924 3.0423 54.1587L11.7982 32.2518C12.1192 31.4485 12.1192 30.5518 11.7982 29.7485L3.0423 7.84152Z",
    fill: "url(#paint1_linear_974_11211)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_974_11211_clip_path",
    transform: "translate(27.1348 26.9316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8777 29.7164L3.12182 7.80942C1.97785 4.94724 4.86662 2.13263 7.6819 3.36641L63.5285 27.8408C66.275 29.0445 66.275 32.9557 63.5285 34.1594L7.68191 58.6338C4.86663 59.8676 1.97786 57.053 3.12183 54.1908L11.8777 32.2839C12.207 31.46 12.207 30.5403 11.8777 29.7164Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_974_11211_clip_path",
    transform: "translate(27.2207 27.0181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6477 3.4454C4.90281 2.24246 2.08626 4.98671 3.20163 7.77734L11.9575 29.6843C12.295 30.5288 12.295 31.4715 11.9575 32.316L3.20163 54.2229C2.08626 57.0135 4.90281 59.7578 7.64771 58.5548L63.4943 34.0804C66.1722 32.9068 66.1722 29.0934 63.4943 27.9198L7.6477 3.4454ZM3.0423 7.84152C1.86973 4.90779 4.83072 2.02281 7.71638 3.28744L63.563 27.7619C66.3782 28.9956 66.3782 33.0046 63.563 34.2384L7.71639 58.7128C4.83072 59.9774 1.86974 57.0924 3.0423 54.1587L11.7982 32.2518C12.1192 31.4485 12.1192 30.5518 11.7982 29.7485L3.0423 7.84152Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_11211",
    x1: 9.57731,
    y1: 8.22244,
    x2: 73.7425,
    y2: 45.5261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_974_11211",
    x1: 9.50976,
    y1: 8.15196,
    x2: 73.8623,
    y2: 45.5513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCurrencyItem2);
export default __webpack_public_path__ + "static/media/multi_currency_item2.27a47562ae49503a78d31fde21df1898.svg";
export { ForwardRef as ReactComponent };